export class BaseSendMessageModel {
	Subject: string;
	Message: string;
	ContentId: number;
	ContentType: NotificationContentType;
	Email: boolean;
	Sms: boolean;
	Push: boolean;
	Note: boolean;
	DirectMessage: boolean;
	DateToSendUtc: Date;
}

export class SendMessageModel extends BaseSendMessageModel {
	Clients: number[];
	BusinessCategories: number[];
	Groups: number[];
}

export class SendMessageToUserModel extends BaseSendMessageModel {
	UserId: string;
}

export class SendMessageToProfileModel extends BaseSendMessageModel {
	BusinessProfileId: number;
}


export enum NotificationContentType {
  None = 0,
  File = 1,
  Sale = 2,
  Tender = 3,
  Job = 4,
  Event = 5,
  Advert = 6,
  Reward = 14,
}


export interface Notification {
	Id: number;
	Subject: string;
	Message: string;
	Group: string;
	ContentType: NotificationContentType;
	ContentTypeDisplay: string;
	Email: boolean;
	Push: boolean;
	Sms: boolean;
	ContentId: number | null;
	ContentIdString: string;
	DateToSendUtc: string | null;
	Deliverables: number;
	Sent: number;
	Read: number;
}

export class CreateNotificationModel extends BaseSendMessageModel {
	subject: string;
	message: string;
	dateToSendUtc: string;
}

export class EditNotificationModel { 
	id: number;
	subject: string;
	message: string;
	dateToSendUtc: Date;
	constructor(item?: Notification) {
		this.id = item && item.Id;
		this.subject = item && item.Subject;
		this.message = item && item.Message;
		if (item != null && item.DateToSendUtc != null && item.DateToSendUtc.indexOf('Z') < 0) {
			item.DateToSendUtc += "Z";
		}
		this.dateToSendUtc = item && new Date(item.DateToSendUtc);
	}
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/MessageModel.ts